import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from "@angular/router";
import { environment } from "../../../environments/environment";

declare var Superchat: any;

@Injectable({
  providedIn: 'root'
})
export class SuperChatService {

  constructor(private router: Router) {}

  public initialize() {
    const currentUrl = window.location.href;
    const shouldHideSuperchat = currentUrl.includes('/embedded/');
    const url = "https://widget.superchat.de/sdk.js";
    const superChatScript = document.createElement('script');
    superChatScript.src = `${url}`;
    document.head.appendChild(superChatScript);

    superChatScript.onload = () => {
      (window as any).Superchat.init({
        applicationKey: 'WCO4MR0Xda8EqWqLr23LJQoj7e', // required
        hideWidget: shouldHideSuperchat, // optional, set `true` to hide the web widget by default
      })
      Superchat = (window as any).Superchat;
    }

    this.onRouteChange();
  }

  private onRouteChange() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd && Superchat) {
        const currentUrl = event.url;
        const shouldHideSuperchat = currentUrl.includes('/embedded/');
        if (shouldHideSuperchat) {
          Superchat.hide();
        } else {
          Superchat.show();
        }
      }
    });
  }
}
